import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { IconTallymark1 } from '@tabler/icons-react';

import { Box, Card, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { useBreadcrumbs } from '@hooks/use-breadcrumbs';

import {
  LayoutBreadcrumbsDividerStyled,
  layoutBreadcrumbsLinkSX,
  LayoutBreadcrumbsMuiBreadcrumbsStyled,
  layoutBreadcrumbsTitleTypographySX,
} from './styled';
import { LayoutBreadCrumbsType } from './types';

export const LayoutBreadcrumbs: LayoutBreadCrumbsType = (props) => {
  const {
    card,
    divider,
    maxItems,
    navigation,
    rightAlign,
    separator,
    ...others
  } = props;

  const theme = useTheme();

  const breadCrumbsItems = useBreadcrumbs({ navigation });

  const breadCrumbsContent = useMemo(() => {
    return breadCrumbsItems.map((item, index) =>
      index !== breadCrumbsItems.length - 1 ? (
        <Typography
          key={item.url}
          component={Link}
          to={item.url}
          variant="subtitle1"
          sx={layoutBreadcrumbsLinkSX}
        >
          {item.title}
        </Typography>
      ) : (
        <Typography
          key={item.url}
          variant="subtitle1"
          sx={layoutBreadcrumbsTitleTypographySX}
        >
          {item.title}
        </Typography>
      )
    );
  }, [breadCrumbsItems]);

  // item separator
  const SeparatorIcon = separator!;
  const separatorIcon = separator ? (
    <SeparatorIcon
      stroke="1.5" //
      width="1rem"
      height="1rem"
    />
  ) : (
    <IconTallymark1
      stroke={2} //
      size={16}
    />
  );

  return (
    <Card
      sx={{
        background:
          card === false ? 'transparent' : theme.palette.background.default,
      }}
      {...others}
    >
      <Box sx={{ p: 1, pl: card === false ? 0 : 2 }}>
        <Grid
          container
          direction={rightAlign ? 'row' : 'column'}
          justifyContent={rightAlign ? 'space-between' : 'flex-start'}
          alignItems={rightAlign ? 'center' : 'flex-start'}
          spacing={1}
        >
          <Grid item>
            <LayoutBreadcrumbsMuiBreadcrumbsStyled
              aria-label="breadcrumb"
              maxItems={maxItems || 8}
              separator={separatorIcon}
            >
              {breadCrumbsContent}
            </LayoutBreadcrumbsMuiBreadcrumbsStyled>
          </Grid>
        </Grid>
      </Box>
      {!(card === false && divider !== false) ? null : (
        <LayoutBreadcrumbsDividerStyled />
      )}
    </Card>
  );
};
